<!--  -->
<template>
    <div class="live">直播服务</div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {

    }
}
</script>
<style scoped lang='scss'>
/* @import url(); 引入css类 */

</style>